define(["dojo-proxy-loader?name=dojo/_base/declare!/home/jenkins/agent/workspace/mailchimp-cd/MC-Mono-Build/node_modules/@mc/webpack-plugin-legacy-dojo/src/modules/noop-module"], function (declare) {
  return declare([], {
    constructor: function (params) {
      this.inherited(arguments);
      var burger = document.querySelector(".burger-container");
      if (burger) {
        burger.addEventListener("click", function () {
          document.querySelector(".mc-nav-container").classList.toggle("menu-opened");
        });
      }
      document.addEventListener("click", function (event) {
        if (!event.target.matches(".menu-item-link")) {
          return;
        }
        document.querySelector(".mc-nav-container").classList.remove("menu-opened");
      }, false);
    }
  });
});